import { Button, Card } from "antd"
import React from "react"
import { useCookies } from "react-cookie"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useLoggedInUserProfile } from "Shared/hooks/user.hooks"
import { LocalStorageService, NotificationService } from "Shared/services"
import { NotificationTypeEnum } from "Shared/services/notification.service"
import { logout } from "Shared/store/actions/auth/authActions"
import { createCompanyIdCookieName } from "Shared/utils/cookie.utils"
import { isDev } from "Shared/utils/helpers"

interface TroubleShootingSettingsInterface {}

const TroubleShootingSettings: React.FC<TroubleShootingSettingsInterface> = ({}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const profile = useLoggedInUserProfile()
    const [_cookies, _setCookie, removeCookie] = useCookies()

    const onTroubleshoot = async () => {
        // log out first to avoid infinite loop of reconnection
        const companyIdCookieName = createCompanyIdCookieName(profile)
        await dispatch(logout())

        // clear cookies
        removeCookie(companyIdCookieName, { secure: true, sameSite: "lax", path: "/", ...(!isDev && { domain: ".finway.de" }) })
        removeCookie("refreshToken")

        // clear storage
        await LocalStorageService.clear()

        NotificationService.send(
            NotificationTypeEnum.SUCCESS,
            t("notification:settings.troubleshooting.cleared.title"),
            t("notification:settings.troubleshooting.cleared.message"),
            10
        )
    }

    return (
        <div id="finway-troubleshooting-settings">
            <div className="mt-10">
                <ul className="description-list">
                    <li>
                        <span className="title w-180">{t("label:troubleshooting")}</span>
                        <span className="text text-left"></span>
                        <span onClick={onTroubleshoot} className="text text-left">
                            <Button style={{ whiteSpace: "normal", height: "100%" }} className="btn-default">
                                {t("action:troubleshooting.clear_cache_and_cookies")}
                            </Button>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default TroubleShootingSettings
